import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import {
  afd_clip_path_group,
  afd_footer_logo_2,
  afd_logo_bofoundation,
  afd_social_media_icon_facebook,
  afd_social_media_icon_instagram,
  afd_social_media_icon_linkedin,
  afd_social_media_icon_youtube,
} from "../imgs";
import config from "../config";
import { MyBackTop } from "../components/MyBackTop";

const FooterView = observer(() => {
  const { t } = useTranslation();

  const iconList = [
    {
      icon: afd_social_media_icon_facebook,
      url: config.REACT_APP_URL_FACEKOOK,
    },
    {
      icon: afd_social_media_icon_youtube,
      url: config.REACT_APP_URL_YOUTUBE,
    },
    {
      icon: afd_social_media_icon_instagram,
      url: config.REACT_APP_URL_IN,
    },
    {
      icon: afd_social_media_icon_linkedin,
      url: config.REACT_APP_URL_LINKEDIN,
    },
  ];

  const openExternal = (url: string) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="mt-[0px] bg-[#F9F8F0]">
      {/* 等比展示完整草地和米仔，避免固定高度裁掉脚部。 */}
      <div className="mx-auto w-full max-w-[800px]">
        <img
          src={afd_clip_path_group}
          alt=""
          className="block h-auto w-full"
          style={{ objectFit: "contain" }}
        />
      </div>

      {/* 参考稿的白区为左右两栏，图标与机构资料同排；手机空间不足时再换行。 */}
      <div className="mx-auto w-full max-w-[800px] bg-[white] px-[24px] py-[20px] sm:px-[48px]">
        <div className="mx-auto flex max-w-[640px] flex-wrap items-center justify-between gap-x-[32px] gap-y-[18px]">
          <div>
            <img
              src={afd_logo_bofoundation}
              alt="Bo Charity Foundation"
              className="w-[140px] max-w-full"
            />

            <div className="mt-[8px] text-[12px] leading-[1.7] text-[#666666]">
              <div>{t("footer.copyright")}</div>
              <div>{t("footer.company_line")}</div>
              <div>{t("footer.file_no")}</div>
            </div>

            <button
              className="mt-[8px] bg-transparent p-0 text-[14px] font-[500] text-[#666666]"
              onClick={() =>
                openExternal("https://www.foodangel.org.hk/zh-hk/disclaimer")
              }
            >
              {t("footer.disclaimer")}
            </button>
          </div>

          <div className="flex shrink-0 items-center gap-[10px]">
            {iconList.map((item, index) => (
              <button
                key={index}
                aria-label={
                  ["Facebook", "YouTube", "Instagram", "LinkedIn"][index]
                }
                className="bg-transparent p-0"
                onClick={() => openExternal(item.url)}
              >
                <img
                  src={item.icon}
                  alt=""
                  className="h-[36px] w-[36px] object-contain"
                />
              </button>
            ))}
          </div>
        </div>
      </div>

      <div className="mx-auto w-full max-w-[800px] bg-[#E71F76] px-[20px] py-[9px]">
        <img
          src={afd_footer_logo_2}
          alt=""
          className="mx-auto h-[30px] w-auto max-w-[280px]"
        />
      </div>

      <MyBackTop />
    </div>
  );
});

export default FooterView;
